(function () {
    'use strict';

    angular
        .module('app.advertiserAddInfluencerToCampaigns')
        .factory('advertiserAddInfluencerToCampaignsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes));
                            }
                        })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAvailableCampaignsToAddInfluencer(company_id, influencer_id) {
                    var url = $rootScope.apiUrl + 'campaign/' + company_id + '/getAvailableCampaignsToAddInfluencer/' + influencer_id;
                    return handleRequest(url, 'GET', null, true);
                }

                function addInfluencerToCampaigns(data) {
                    var url = $rootScope.apiUrl + 'campaign/addOneInfluencerToCampaigns';
                    return handleRequest(url, 'POST', data, true);
                }

                service.getAvailableCampaignsToAddInfluencer = getAvailableCampaignsToAddInfluencer;
                service.addInfluencerToCampaigns = addInfluencerToCampaigns;

                return service;
            }
        ]);
})();
